export const styles = {
  a: {
    variant: 'links.default',
  }
};
